import { EOnboaringFormStep } from '@constants';
import { Form } from 'antd';
import { useEffect, useState } from 'react';

import { getStepValidationConfig } from '../config/stepValidationConfig';

import { useOnboardingFormLogic, useRegionalization } from '@/hooks';
import { useMySubscriptions } from '@/store';

export const useFormValidation = () => {
  const form = Form.useFormInstance();
  const {
    currentStep,
    userInfo: { isUserFromPCE }
  } = useOnboardingFormLogic();
  const { planificableSubscriptions = [] } = useMySubscriptions();
  const { uni: uniRegionConfig } = useRegionalization();

  const [isValid, setIsValid] = useState(false);
  const formValues = Form.useWatch([], form);

  const goBackHidden = currentStep === EOnboaringFormStep.COMPLETE_PROFILE;

  useEffect(() => {
    const validateStep = async () => {
      if (currentStep === EOnboaringFormStep.SUBJECT_NOTES) {
        const subjects = form.getFieldValue(['userInfo', 'uniUserInfo', 'subjects']) || [];
        const hasValidNotes = subjects.every((s: { note: number | string | undefined }) => {
          if (!s.note) {
            return true;
          }
          const note = Number(s.note);
          const { min, max } = uniRegionConfig.grade;
          const isValidNote = !isNaN(note) && note >= min && note <= max;
          return isValidNote;
        });

        setIsValid(hasValidNotes);
        return;
      }

      const stepConfig = getStepValidationConfig({ isPce: isUserFromPCE })[currentStep];
      if (!stepConfig) {
        setIsValid(true);
        return;
      }

      try {
        await form.validateFields(stepConfig.requiredFields, { validateOnly: true });
        setIsValid(true);
      } catch (error) {
        setIsValid(false);
      }
    };

    validateStep();
  }, [currentStep, formValues, form, planificableSubscriptions]);

  return { isButtonDisabled: !isValid, goBackHidden };
};
